import React from 'react'

const NotFound = () => (
  <div className='center'>
    The page you were looking for could not be found.
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/components/404/index.js